export default __webpack_public_path__ + "static/media/Arrow_active.355b6389.svg";